// Атрибуты <img> для картинок витрины, каталога и подсказок (изменение seo, design.md, решение 7):
// WebP нужной ширины через srcset, JPEG — запасной src; ленивая загрузка ниже первого экрана.
// Ширины WebP — из pictures.generated.ts (design/web_images.py).
import { PICTURE_VARIANTS } from "./pictures.generated";

// lead — главная картинка страницы: грузится первой; eager — первый экран; lazy — ниже.
export type PicturePriority = "lead" | "eager" | "lazy";

export type PictureAttributes = {
  src: string;
  srcSet?: string;
  sizes?: string;
  loading: "eager" | "lazy";
  decoding: "async";
  fetchPriority?: "high";
};

export function picture(src: string, sizes: string, priority: PicturePriority = "lazy"): PictureAttributes {
  const attributes: PictureAttributes = {
    src,
    loading: priority === "lazy" ? "lazy" : "eager",
    decoding: "async",
  };
  if (priority === "lead") attributes.fetchPriority = "high";
  const variants = PICTURE_VARIANTS[src];
  if (variants === undefined || variants.length === 0) return attributes;
  const stem = src.replace(/\.jpg$/, "");
  attributes.srcSet = variants.map((variant) => `${stem}-${variant.label}.webp ${variant.width}w`).join(", ");
  attributes.sizes = sizes;
  return attributes;
}

// Размеры на экране: колонка телефона, половина и треть ряда, широкий экран.
export const SIZES_FULL = "(min-width: 900px) 560px, 100vw";
export const SIZES_HALF = "(min-width: 900px) 360px, 50vw";
export const SIZES_THIRD = "(min-width: 900px) 240px, 33vw";
export const SIZES_THUMB = "160px";
